import React from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import UserWalletTopUpModal from 'pages/users/wallets/UserWalletTopUpModal';
import utils from 'helpers/utils';

const UserWalletsList = (props, context) => {
    const { refreshWallets, resource, wallets } = props;

    return (
        <Table responsive='scroll'>
            <TableRow>
                <HeaderColumn style={ { width: '45%' } }>
                    <FieldTitle
                        label='fields.currency'
                        resource={ resource }
                        source='currency'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '45%' } }>
                    <FieldTitle
                        label='resources.wallets.fields.balance'
                        resource={ resource }
                        source='balance'
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '10%' } }>&nbsp;</HeaderColumn>
            </TableRow>

            { wallets.map((wallet) => {
                return (
                    <TableRow
                        key={ wallet.id }
                    >
                        <TableBodyCell
                            field={ <TextField value={ wallet.currency } /> }
                            record={ wallet }
                            source='currency'
                        />

                        <TableBodyCell
                            field={ <TextField value={ utils.formatPrice(wallet.balance, wallet.currency, context.config.language.system) } /> }
                            record={ wallet }
                            source='balance'
                        />

                        <TableBodyCell
                            field={
                                <UserWalletTopUpModal refreshWallets={ refreshWallets } initialValues={ wallet } />
                            }
                            record={ wallet }
                        />
                    </TableRow>
                );
            }) }
        </Table>
    );
};

UserWalletsList.contextTypes = {
    config: PropTypes.object,
};

UserWalletsList.defaultProps = {
    resource: 'wallets',
};

UserWalletsList.propTypes = {
    refreshWallets: PropTypes.func.isRequired,
    resource: PropTypes.string,
    wallets: PropTypes.arrayOf(PropTypes.shape({
        balance: PropTypes.number,
        currency: PropTypes.string,
        id: PropTypes.number,
    })).isRequired,
};

export default UserWalletsList;



// WEBPACK FOOTER //
// ./src/pages/users/wallets/UserWalletsList.js